import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { Contact, ContactField } from "@models";

import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { Service } from "./base-service";
import { SocketService } from "./socket.service";

import { Helper, parseObject } from "@helpers/functions";
import { InitService } from "@core-services/init.service";
import { ServiceNames } from "@models/service_enums";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { InfoService } from "@core-services/info.service";
import { New_ContactsFacade } from "@modules/new_contacts/domain/+state/new_contacts.facade";

const name = ServiceNames.CONTACT;

// TODO: eslint fix
/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
	providedIn: "root"
})
export class ContactService extends Service<Contact> {
	public name: string = ServiceNames.CONTACT;

	public fetchContact(contactId: string): Observable<Contact> {
		return this.apicallService.get("contact/" + contactId).pipe(map((res) => parseObject(res, Contact)));
	}

	private apiOption = new ApicallOption(Contact);

	public constructor(
		private apicallService: ApicallService,
		private socketService: SocketService,
		private translationService: TranslationService,
		protected destructor: DestructorService,
		private infoService: InfoService,
		protected initService: InitService,
		private readonly contactsFacade: New_ContactsFacade
	) {
		super(initService, destructor, name);
	}

	public get contacts(): Contact[] {
		return this.list;
	}

	public set contacts(value: Contact[]) {
		this.list = value;
		this.initService.init(this.name);
	}

	public deleteContact(contact: Contact): void {
		this.apicallService.deleteRequest("contact/" + contact.getId(), this.apiOption).subscribe(
			(contacts) => {
				this.list = contacts;
				this.contactsFacade.updateContacts(contacts.filter((contact: Contact) => !contact.isDeleted()));
				this.infoService.setSuccess(this.translationService.translate("info_text_contact_deleted"));
			},
			(error) => Helper.handleError(error)
		);
	}

	public sorted(contacts: Contact[]): Contact[] {
		return contacts.sort((c1, c2) => c2.getLastUsed().getUnix() - c1.getLastUsed().getUnix());
	}

	public findByContactField(field: ContactField): Contact {
		return this.findByRecipient(field.getValue()) || new Contact();
	}

	public findContactByDestinationTag(field: ContactField): Contact {
		return this.findByDestinationTag(field.getValue(), field.getDestinationTag()) || new Contact();
	}

	public findByRecipient(recipient: string): Contact {
		return this.contacts.find((c) => c.getFields().some((cf) => cf.getValue() === recipient));
	}

	public findByDestinationTag(value: string, tag: string): Contact {
		return this.contacts.find((c) =>
			c.getFields().some((cf) => cf.getValue() === value && cf.getDestinationTag() === tag)
		);
	}

	public upsertCall(data: Contact): Observable<any> {
		data.clearError();
		let upsertObservable: Observable<any>;

		if (data.isNew()) {
			upsertObservable = this.apicallService.post("contacts", new ApicallOption(Contact, data));
		} else {
			upsertObservable = this.apicallService.put("contact/" + data.getId(), new ApicallOption(Contact, data));
		}
		return upsertObservable.pipe(
			map(
				(contact) => this.upsert(contact[0]),
				(error) => error
			)
		);
	}
}
